// Apparel-size sort key. Lower = smaller.
//
// Covers the SanMar size strings we ship with: standard adult lettered
// (XS..6XL), youth (YXS..YXL), ladies (LXS..LXL or "Ladies XS"), tall
// (LT, XLT, 2XLT...), and numeric/dress sizes (2, 4, 6, ..., 24).
//
// Anything we don't recognize sorts after the known sizes in alphabetical
// order so it stays deterministic.

const ORDER = [
  // Hat / one-size
  'OSFA', 'OS', 'ONE SIZE',
  // Youth
  'YXS', 'YS', 'YM', 'YL', 'YXL',
  // Adult standard
  'XXS', 'XS', 'S', 'M', 'L', 'XL',
  '2XL', 'XXL', '3XL', 'XXXL', '4XL', '5XL', '6XL',
  // Ladies (uppercase L prefix)
  'LXS', 'LS', 'LM', 'LL', 'LXL', 'L2XL', 'L3XL',
  // Tall
  'LT', 'XLT', '2XLT', 'XXLT', '3XLT', 'XXXLT', '4XLT',
];

const INDEX = new Map(ORDER.map((s, i) => [s.toUpperCase(), i]));

export function sizeKey(size) {
  if (size == null) return Number.MAX_SAFE_INTEGER;
  const k = String(size).trim().toUpperCase();

  const idx = INDEX.get(k);
  if (idx !== undefined) return idx;

  // Numeric dress / waist sizes (e.g. "4", "32", "32x34")
  const numMatch = k.match(/^(\d+)(?:[xX](\d+))?$/);
  if (numMatch) {
    return 1000 + parseInt(numMatch[1], 10) + (numMatch[2] ? parseInt(numMatch[2], 10) / 100 : 0);
  }

  // "Ladies XL", "Ladies S" etc — strip prefix and try again
  const ladiesMatch = k.match(/^(?:LADIES|WOMEN'?S?)\s+(.+)$/);
  if (ladiesMatch) {
    const stripped = INDEX.get(ladiesMatch[1]);
    if (stripped !== undefined) return 500 + stripped;
  }

  // Fallback: alphabetical, after all known sizes
  return 10000 + k.charCodeAt(0);
}

// Convenience: sort an array of size strings in apparel order.
export function sortSizes(sizes) {
  return [...sizes].sort((a, b) => sizeKey(a) - sizeKey(b));
}

// Convenience: sort a {size: qty, ...} map's entries by size order.
export function sortSizeEntries(entries) {
  return [...entries].sort(([a], [b]) => sizeKey(a) - sizeKey(b));
}
